import * as React from 'react';
export const huntingtonSvg = React.forwardRef(function huntingtonSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#6ABE44',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm9.51 9.59 2.6-1.52v6.6l4.32-2.21v-6.4l2.55 1.48v6.3l-6.87 3.43V24l-2.6-1.45V9.59zm-.86.5v11.97l-1.73-.97V11.1l1.73-1zm4.37-2.55 2.5-1.46v5.98l-2.5 1.2V7.54zm0 16.98v-6.85l6.87-3.43V8.07l2.6 1.52v12.96L19.89 24v-6.68l-4.32 2.21v6.42l-2.55-1.43zm3.46 1.4v-5.99l2.5-1.2v5.79l-2.5 1.4zm6.87-15.83 1.73 1.01v10l-1.73.96V10.1z',
      }),
    ),
  );
});
huntingtonSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var huntington = {
  category: 'brand',
  colorable: false,
  name: 'huntington',
  svg: huntingtonSvg,
};
